import animation from './animation';

export default {
  animation,
};
